import { render, staticRenderFns } from "./profession.vue?vue&type=template&id=e6b5c35c"
import script from "./profession.vue?vue&type=script&lang=js"
export * from "./profession.vue?vue&type=script&lang=js"
import style0 from "./profession.vue?vue&type=style&index=0&id=e6b5c35c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports